

















































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import moment from "moment";
import {
  SBAR_COMMUNICATION_LABEL,
  SBAR_SECTIONS,
  SBAR_STATUS_BADGE,
  SBAR_TBAK_STATEMENT,
  SBAR_VERIFY_PLACEHOLDER,
  SbarStatusBadge
} from "@/constants/sbar";
import { ReadbackPerson, ReadbackResponseItem, SbarStatus } from "@/types/cppt";

@Component({
  inject: {
    verifikasiTerkunciFn: {
      from: "isVerifikasiTerkunci",
      default: () => () => false
    }
  }
})
export default class CpptSbarEntry extends Vue {
  @Prop({ required: true }) readonly item!: ReadbackResponseItem;
  @Prop({ required: true }) readonly stateUserId!: number | string;
  @Prop({ type: Boolean, default: false }) readonly readonly!: boolean;
  @Prop({ type: Boolean, default: true }) readonly showVerifButton!: boolean;
  @Prop({ type: Boolean, default: false }) readonly canVerifyDpjp!: boolean;
  @Prop({ type: Boolean, default: false }) readonly verifying!: boolean;
  @Prop({ type: Boolean, default: false }) readonly noteInput!: boolean;
  @Prop({ type: String, default: "" }) readonly note!: string;

  sections = SBAR_SECTIONS;
  notePlaceholder = SBAR_VERIFY_PLACEHOLDER;

  verifikasiTerkunciFn!: () => boolean;

  get verifikasiTerkunci(): boolean {
    return this.verifikasiTerkunciFn();
  }

  get isReporter(): boolean {
    return Number(this.item.consulting_user_id) === Number(this.stateUserId);
  }

  get isConsultant(): boolean {
    return Number(this.item.consultant_user_id) === Number(this.stateUserId);
  }

  get dpjpIsConsultant(): boolean {
    return (
      !!this.item.dpjp_user_id &&
      Number(this.item.dpjp_user_id) === Number(this.item.consultant_user_id)
    );
  }

  get status(): SbarStatus {
    if (this.item.sbar_status) {
      return this.item.sbar_status;
    }
    if (!this.item.responded_at) {
      return "draft";
    }

    return this.item.consultant_verified_at
      ? "terverifikasi"
      : "menunggu_verifikasi";
  }

  get badge(): SbarStatusBadge | null {
    return SBAR_STATUS_BADGE[this.status];
  }

  get hasResponse(): boolean {
    return this.status !== "draft";
  }

  get isVerified(): boolean {
    return this.status === "terverifikasi";
  }

  get awaitingVerification(): boolean {
    return this.status === "menunggu_verifikasi";
  }

  get communicationLabel(): string {
    return this.item.communication_method
      ? SBAR_COMMUNICATION_LABEL[this.item.communication_method]
      : "-";
  }

  get responseNote(): string {
    return this.item.readback_confirmed_at
      ? SBAR_TBAK_STATEMENT
      : `Instruksi diterima melalui ${this.communicationLabel}`;
  }

  get pendingVerificationText(): string {
    return this.isConsultant
      ? "Perlu konfirmasi & tanda tangan digital DPJP"
      : `Menunggu verifikasi ${this.nama(this.item.consultant)}`;
  }

  get isDpjpVerifiedOnTime(): boolean {
    return (
      moment(this.item.dpjp_verified_at).diff(
        moment(this.item.consulting_at),
        "hours"
      ) <= 24
    );
  }

  get canEdit(): boolean {
    return (
      !this.readonly && this.isReporter && !this.item.consultant_verified_at
    );
  }

  get showNoteInput(): boolean {
    return this.noteInput && this.isConsultant && this.awaitingVerification;
  }

  get canVerifyConsultant(): boolean {
    return (
      this.showVerifButton &&
      this.isConsultant &&
      this.awaitingVerification
    );
  }

  get canVerifyAsDpjp(): boolean {
    return (
      this.showVerifButton &&
      this.canVerifyDpjp &&
      this.isVerified &&
      !this.item.dpjp_verified_at
    );
  }

  nama(person: ReadbackPerson | null | undefined): string {
    return person?.nama || "-";
  }

  formatDate(date: string | null | undefined): string | null {
    return date ? moment(date).format("DD-MM-YYYY HH:mm") : null;
  }
}
